module.exports = __webpack_public_path__ + "static/media/Scott Price.44905a46.png";